import { render, staticRenderFns } from "./InfoDialog.vue?vue&type=template&id=1bc2ea92&scoped=true&"
import script from "./InfoDialog.vue?vue&type=script&lang=js&"
export * from "./InfoDialog.vue?vue&type=script&lang=js&"
import style0 from "./InfoDialog.vue?vue&type=style&index=0&id=1bc2ea92&scoped=true&lang=less&"
import style1 from "./InfoDialog.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc2ea92",
  null
  
)

export default component.exports